module.exports = __webpack_public_path__ + "img/logout-icon.935733ed.svg";